import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  inheritText: {
    fontWeight: 'inherit',
    color: 'inherit'
  },

  buttonLink: {
    width: 'auto !important',
    height: 'auto !important',
    padding: 0,
    fontWeight: 'inherit',
    fontSize: 'inherit',
    '&>*': {
      fontWeight: 'inherit',
      fontSize: 'inherit'
    }
  }
}))
